<template>
    <div>
        <b-overlay
            :show="dataOverlay"
            spinner-variant="success"
            no-wrap
        ></b-overlay>
        <div class="d-flex justify-content-start align-items-center mb-4">
            <div>
                <h5 class="m-0">Детали страхования <span class="text-secondary">{{ items.policy_number }}</span> (#{{ items.id }})</h5>
            </div>
            <div class="ml-3">
                <b-badge variant="success" class="always-small-badge" v-if="items.is_available"><i class='bx bx-check'></i> Полис в наличии</b-badge>
                <b-badge variant="danger" class="always-small-badge" v-else>Полис не в наличии</b-badge>
            </div>
        </div>
        <table class="table table-hover table-borderless table-fixed">
            <tbody>
                <tr>
                    <td class="table-title-details">Компания</td>
                    <td>
                        <template v-if="items.company">
                            {{ items.company.name }} ({{ items.company.inn }})
                        </template>
                        <template v-else>
                            Не указано
                        </template>
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">Тип страхования</td>
                    <td>
                        <template v-if="items.insurance_type">
                            {{ items.insurance_type.name }}
                        </template>
                        <template v-else>
                            Не указано
                        </template>
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">№ и дата полиса</td>
                    <td>
                        {{ items.policy_number || "Не указано" }} / {{ items.policy_date || "Не указано" }}
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">Срок действия полиса</td>
                    <td>{{ items.policy_expiry || "Не указано" }}</td>
                </tr>
                <tr>
                    <td class="table-title-details">Лимит по полису</td>
                    <td>{{ items.policy_limit || "Не указано" }}</td>
                </tr>
                <tr>
                    <td class="table-title-details">Лимит по разовому случаю</td>
                    <td>{{ items.case_limit || "Не указано" }}</td>
                </tr>
                <tr>
                    <td class="table-title-details">Франшиза, лимит</td>
                    <td>{{ items.franchise_limit || "Не указано" }}</td>
                </tr>
                <tr>
                    <td class="table-title-details">Скан полиса</td>
                    <td>
                        <template v-if="items.scan">
                            <a :href="hfs + items.scan.path" target="_blank">Посмотреть скан &raquo;</a>
                        </template>
                        <template v-else>
                            <span class="text-danger">Скан не приложен!</span>
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import { API_COMPANY_INSURANCE, HOST_FOR_STORAGE } from '../../constants'

    export default {
        props: {
            itemId: { type: Number, required: false },
        },
        data() {
            return {
                api: API_COMPANY_INSURANCE,
                items: '',
                dataOverlay: true,
                hfs: HOST_FOR_STORAGE
            }
        },
        mounted() {
            this.getInsuranceDetails(this.itemId)
        },
        methods: {
            getInsuranceDetails(id) {
                api.call('get', `${this.api}/${id}`).then(({ data }) => {
                    this.items = data
                    this.dataOverlay = false
                })
            }
        }
    }
</script>
<style scoped>
    .always-small-badge {
        font-size: 0.75rem;
    }
    .table-title-details {
        font-weight: bold;
        width: 200px;
    }
</style>
